<template>
  <div class="my_content">
    <div class="my_info">
      <div class="my_user_img">
        <div class="my_img">
          <!-- <van-uploader
            result-type="file"
            v-model="fileList"
            multiple
            :max-count="1"
            :after-read="UploadHeaderImage"
          /> -->
          <van-image
            round
            width="80px"
            height="80px"
            :src="UserInfo.CompleteImages"
          />
        </div>
        <div class="my_user">{{ UserInfo.Name }}</div>
      </div>
    </div>
    <div class="my_info_opt">
      <van-cell title="我的订单" is-link to="myorder" />
      <van-cell
        v-if="UserInfo.AccountType != 100"
        title="我的地址"
        is-link
        to="addresslist"
      />
      <van-cell v-if="UserInfo.AccountType != 100" title="我的信息"  is-link to="userEdit" />
    </div>
    <div class="my_login">
      <van-button
        v-if="UserIsAuthenticated"
        color="linear-gradient(to right, #ff6034, #ee0a24)"
        round
        :block="true"
        type="primary"
        @click="OutLogin"
        >退出</van-button
      >
    </div>
  </div>
  <van-overlay :show="!UserIsAuthenticated">
    <div class="wrapper" @click.stop>
      <div class="block">
        <router-link to="login">
          <van-button
            color="linear-gradient(to right, #ff6034, #ee0a24)"
            round
            :block="true"
            type="primary"
            >登录</van-button
          >
        </router-link>
      </div>
    </div>
  </van-overlay>
  <tabbar :active="2" />
</template>
<script >
import tabbar from "../components/tabbars/tabbar.vue"
import axios from "../commons/AxiosMethod.js"
import axiosfile from "axios"
export default {
  data () {
    return {
      index: 0,
      clientWidth: document.body.clientWidth,
      clientHeight: document.documentElement.clientHeight,
      UserIsAuthenticated: true, // 用户是否登录
      UserInfo: {},
      UploadImageUrl: "",
      UploadPictureImageUrl: "",
      headersImage: {},

      fileList: [] //
    }
  },
  name: "App",
  mounted () {
    this.UploadImageUrl = axios.GetUrl() + "/api/Upload/ImageFile"
    this.UploadPictureImageUrl =
      axios.GetUrl() + "/api/Upload/UploadPictureSuccess"
    this.headersImage = {
      Authorization: localStorage.getItem("Authentication_Header")
    }

    this.GetUserIsAuthenticated()
  },
  components: {
    tabbar
  },
  methods: {
    // 上传头像
    UploadHeaderImage (file) {
      const formData = new FormData()
      formData.append("uploadFile", this.fileList[0].file)

      const config = {
        headers: {
          "Content-Type":
            "multipart/form-data;boundary=" + new Date().getTime(),
          Authorization: localStorage.getItem("Authentication_Header"),
          "Access-Control-Allow-Origin": "*"
        }
      }

      axiosfile
        .post("/api/Upload/ImageFile", formData, config)
        .then(function (response) {
          var imgs = {
            url: response.data.ImageFormet
          }
          this.fileList = []
          this.fileList.push(imgs)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 退出登录
    OutLogin () {
      localStorage.setItem("Authentication_Header", "")
      this.$router.push({
        path: "product_categorys"
      })
    },
    // 验证是否登录
    GetUserIsAuthenticated () {
      var param = {
        Account: this.Account,
        Password: this.Password
      }
      axios.apiMethod(
        "/api/User/GetUserIsAuthenticated",
        "get",
        param,
        (result) => {
          if (result.Code == 200) {
            if (result.Data.Type == 401) {
              this.UserIsAuthenticated = false
              return
            }
            this.GetUserInfo()
          }
        }
      )
    },
    // 获取用户信息
    GetUserInfo () {
      var param = {}
      axios.apiMethod("/api/User/GetUserInfo", "get", param, (result) => {
        if (result.Code == 200) {
          this.UserInfo = result.Data
          var imgs = {
            url: this.UserInfo.CompleteImages
          }
          this.fileList = []
          this.fileList.push(imgs)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.my_content {
  padding: 10px;
  .my_info {
    background-color: #fff;
    height: 140px;
    padding: 10px;
    border-radius: 5px;
    .my_user_img {
      width: 120px;
      background-color: #eee;
      height: 130px;
      padding: 5px;
      text-align: center;
      .my_user {
        margin-top: 20px;
      }
    }
  }
  .my_info_opt {
    margin-top: 20px;
  }
}
.my_login {
  width: 100%;
  margin-top: 40px;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: calc(100% - 40px);
  height: 120px;
}
</style>
